export default __webpack_public_path__ + "static/media/completed_project_icon.ca92b141.svg";